import React from 'react';
import {
  PuzzlePiece20Regular,
  Color20Regular,
  ShapeSubtract20Regular,
  Lightbulb20Regular,
  Emoji20Regular,
} from '@fluentui/react-icons';

export const getOptions = (i18n, usedOptions) => ([
  {
    key: 'keyElements',
    text: i18n.getString(_TL_('Key elements')),
    icon: <PuzzlePiece20Regular />,
    words: ([
      { key: 'key_0', word: i18n.getString(_TL_('With clouds')) },
      { key: 'key_1', word: i18n.getString(_TL_('With mountains')) },
      { key: 'key_2', word: i18n.getString(_TL_('On a beach')) },
      { key: 'key_3', word: i18n.getString(_TL_('On the coast')) },
      { key: 'key_4', word: i18n.getString(_TL_('With vibrant foliage')) },
      { key: 'key_5', word: i18n.getString(_TL_('In a studio')) },
      { key: 'key_6', word: i18n.getString(_TL_('In autumn')) },
      { key: 'key_7', word: i18n.getString(_TL_('In winter')) },
      { key: 'key_8', word: i18n.getString(_TL_('In summer')) },
      { key: 'key_9', word: i18n.getString(_TL_('In spring')) },
      { key: 'key_10', word: i18n.getString(_TL_('Outdoors')) },
      { key: 'key_11', word: i18n.getString(_TL_('On a sleek desk')) },
      { key: 'key_12', word: i18n.getString(_TL_('In a vibrant market')) },
      { key: 'key_13', word: i18n.getString(_TL_('With indoor plants')) },
      { key: 'key_14', word: i18n.getString(_TL_('In a modern kitchen')) },
      { key: 'key_15', word: i18n.getString(_TL_('On a marble countertop')) },
      { key: 'key_16', word: i18n.getString(_TL_('In front of a modern building')) },
      { key: 'key_17', word: i18n.getString(_TL_('With a laptop')) },
      { key: 'key_18', word: i18n.getString(_TL_('In a boutique')) },
      { key: 'key_19', word: i18n.getString(_TL_('In a stylish home office')) },
      { key: 'key_20', word: i18n.getString(_TL_('In a park')) },
      { key: 'key_21', word: i18n.getString(_TL_('With tropical plants')) },
      { key: 'key_22', word: i18n.getString(_TL_('With balloons and confetti')) },
      { key: 'key_23', word: i18n.getString(_TL_('On a table')) },
      { key: 'key_24', word: i18n.getString(_TL_('In a sunny backyard')) },
      { key: 'key_25', word: i18n.getString(_TL_('With cozy decor')) },
      { key: 'key_26', word: i18n.getString(_TL_('In a dining room')) },
      { key: 'key_27', word: i18n.getString(_TL_('In a living room')) },
      { key: 'key_28', word: i18n.getString(_TL_('On an urban street')) },
    ]).filter(option => !usedOptions.find(usedOption => usedOption.key === option.key)),
  },
  {
    key: 'mood',
    text: i18n.getString(_TL_('Mood')),
    icon: <Emoji20Regular />,
    words: ([
      { key: 'mood_key_0', word: i18n.getString(_TL_('Warm and inviting')) },
      { key: 'mood_key_1', word: i18n.getString(_TL_('Adventurous')) },
      { key: 'mood_key_2', word: i18n.getString(_TL_('Nostalgic')) },
      { key: 'mood_key_3', word: i18n.getString(_TL_('Energetic and playful')) },
      { key: 'mood_key_4', word: i18n.getString(_TL_('Elegant and sophisticated')) },
      { key: 'mood_key_5', word: i18n.getString(_TL_('Joyful')) },
      { key: 'mood_key_6', word: i18n.getString(_TL_('Serene')) },
      { key: 'mood_key_7', word: i18n.getString(_TL_('Romantic')) },
      { key: 'mood_key_8', word: i18n.getString(_TL_('Mysterious')) },
      { key: 'mood_key_9', word: i18n.getString(_TL_('Cozy')) },
      { key: 'mood_key_10', word: i18n.getString(_TL_('Bold')) },
      { key: 'mood_key_11', word: i18n.getString(_TL_('Peaceful')) },
      { key: 'mood_key_12', word: i18n.getString(_TL_('Dynamic')) },
      { key: 'mood_key_13', word: i18n.getString(_TL_('Dramatic')) },
      { key: 'mood_key_14', word: i18n.getString(_TL_('Contemplative')) },
      { key: 'mood_key_15', word: i18n.getString(_TL_('Futuristic')) },
      { key: 'mood_key_16', word: i18n.getString(_TL_('Whimsical')) },
      { key: 'mood_key_17', word: i18n.getString(_TL_('Calm and tranquil')) },
      { key: 'mood_key_18', word: i18n.getString(_TL_('Fresh and invigorating')) },
      { key: 'mood_key_19', word: i18n.getString(_TL_('Intimate')) },
      { key: 'mood_key_20', word: i18n.getString(_TL_('Bright and cheerful')) },
      { key: 'mood_key_21', word: i18n.getString(_TL_('Celebratory')) },
    ]).filter(option => !usedOptions.find(usedOption => usedOption.key === option.key)),
  },
  {
    key: 'style',
    text: i18n.getString(_TL_('Style')),
    icon: <Color20Regular />,
    words: ([
      { key: 'style_key_0', word: i18n.getString(_TL_('Vintage retro')) },
      { key: 'style_key_1', word: i18n.getString(_TL_('Minimalist and clean')) },
      { key: 'style_key_2', word: i18n.getString(_TL_('Modern')) },
      { key: 'style_key_3', word: i18n.getString(_TL_('Candid')) },
      { key: 'style_key_4', word: i18n.getString(_TL_('Artistic')) },
      { key: 'style_key_5', word: i18n.getString(_TL_('High fashion')) },
      { key: 'style_key_6', word: i18n.getString(_TL_('Black and white')) },
      { key: 'style_key_7', word: i18n.getString(_TL_('Architectural')) },
      { key: 'style_key_8', word: i18n.getString(_TL_('Nature-inspired')) },
      { key: 'style_key_9', word: i18n.getString(_TL_('Rural and rustic')) },
      { key: 'style_key_10', word: i18n.getString(_TL_('Cinematic')) },
      { key: 'style_key_11', word: i18n.getString(_TL_('Vibrant')) },
      { key: 'style_key_12', word: i18n.getString(_TL_('Rugged and earthy')) },
      { key: 'style_key_13', word: i18n.getString(_TL_('Chic and fashionable')) },
      { key: 'style_key_14', word: i18n.getString(_TL_('Lush and tropical')) },
      { key: 'style_key_15', word: i18n.getString(_TL_('Bohemian')) },
      { key: 'style_key_16', word: i18n.getString(_TL_('Industrial chic')) },
      { key: 'style_key_17', word: i18n.getString(_TL_('Coastal cottage')) },
      { key: 'style_key_18', word: i18n.getString(_TL_('Art deco')) },
      { key: 'style_key_19', word: i18n.getString(_TL_('Urban street style')) },
      { key: 'style_key_20', word: i18n.getString(_TL_('Sophisticated elegance')) },
      { key: 'style_key_21', word: i18n.getString(_TL_('Whimsical fantasy')) },
      { key: 'style_key_22', word: i18n.getString(_TL_('Timeless and classic')) },
      { key: 'style_key_23', word: i18n.getString(_TL_('Bold and geometric')) },
      { key: 'style_key_24', word: i18n.getString(_TL_('Playful and colorful')) },
      { key: 'style_key_25', word: i18n.getString(_TL_('Dark and moody')) },
      { key: 'style_key_26', word: i18n.getString(_TL_('Soft pastel')) },
      { key: 'style_key_27', word: i18n.getString(_TL_('Grunge aesthetic')) },
    ]).filter(option => !usedOptions.find(usedOption => usedOption.key === option.key)),
  },
  {
    key: 'composition',
    text: i18n.getString(_TL_('Composition')),
    icon: <ShapeSubtract20Regular />,
    words: ([
      { key: 'composition_key_0', word: i18n.getString(_TL_('Close-up view')) },
      { key: 'composition_key_1', word: i18n.getString(_TL_('Front view')) },
      { key: 'composition_key_2', word: i18n.getString(_TL_('Top-down view')) },
      { key: 'composition_key_3', word: i18n.getString(_TL_('Side view')) },
      { key: 'composition_key_4', word: i18n.getString(_TL_('Bird’s eye view')) },
      { key: 'composition_key_5', word: i18n.getString(_TL_('Centered and symmetrical')) },
      { key: 'composition_key_6', word: i18n.getString(_TL_('Asymmetrical balance')) },
      { key: 'composition_key_7', word: i18n.getString(_TL_('Wide shot')) },
      { key: 'composition_key_8', word: i18n.getString(_TL_('High shot')) },
      { key: 'composition_key_9', word: i18n.getString(_TL_('Medium shot')) },
      { key: 'composition_key_10', word: i18n.getString(_TL_('Low angle')) },
      { key: 'composition_key_11', word: i18n.getString(_TL_('Worm’s eye view')) },
      { key: 'composition_key_12', word: i18n.getString(_TL_('Tilted angle')) },
      { key: 'composition_key_13', word: i18n.getString(_TL_('Over-the-shoulder')) },
      { key: 'composition_key_14', word: i18n.getString(_TL_('Extreme close-up view')) },
      { key: 'composition_key_15', word: i18n.getString(_TL_('Reflected angle')) },
      { key: 'composition_key_16', word: i18n.getString(_TL_('Background blur')) },
      { key: 'composition_key_17', word: i18n.getString(_TL_('Panoramic')) },
      { key: 'composition_key_18', word: i18n.getString(_TL_('Extreme long shot')) },
      { key: 'composition_key_19', word: i18n.getString(_TL_('Framed')) },
      { key: 'composition_key_20', word: i18n.getString(_TL_('Leading lines')) },
      { key: 'composition_key_21', word: i18n.getString(_TL_('Layered textures')) },
      { key: 'composition_key_22', word: i18n.getString(_TL_('Reflections in water')) },
      { key: 'composition_key_23', word: i18n.getString(_TL_('Shadow play')) },
      { key: 'composition_key_24', word: i18n.getString(_TL_('Environmental portrait')) },
      { key: 'composition_key_25', word: i18n.getString(_TL_('Action shot')) },
      { key: 'composition_key_26', word: i18n.getString(_TL_('Candid moment')) },
      { key: 'composition_key_27', word: i18n.getString(_TL_('Silhouette against light')) },
      { key: 'composition_key_28', word: i18n.getString(_TL_('Grid layout')) },
      { key: 'composition_key_29', word: i18n.getString(_TL_('Rule of thirds')) },
    ]).filter(option => !usedOptions.find(usedOption => usedOption.key === option.key)),
  },
  {
    key: 'lighting',
    text: i18n.getString(_TL_('Lighting')),
    icon: <Lightbulb20Regular />,
    words: ([
      { key: 'lighting_key_0', word: i18n.getString(_TL_('Natural sunlight')) },
      { key: 'lighting_key_1', word: i18n.getString(_TL_('Golden hour glow')) },
      { key: 'lighting_key_2', word: i18n.getString(_TL_('Bright studio lighting')) },
      { key: 'lighting_key_3', word: i18n.getString(_TL_('Backlighting')) },
      { key: 'lighting_key_4', word: i18n.getString(_TL_('Front lighting')) },
      { key: 'lighting_key_5', word: i18n.getString(_TL_('Dramatic shadows')) },
      { key: 'lighting_key_6', word: i18n.getString(_TL_('Harsh direct light')) },
      { key: 'lighting_key_7', word: i18n.getString(_TL_('Candlelight ambiance')) },
      { key: 'lighting_key_8', word: i18n.getString(_TL_('Neon lights')) },
      { key: 'lighting_key_9', word: i18n.getString(_TL_('Spotlight effect')) },
      { key: 'lighting_key_10', word: i18n.getString(_TL_('Dappled sunlight')) },
      { key: 'lighting_key_11', word: i18n.getString(_TL_('Underwater lighting')) },
      { key: 'lighting_key_12', word: i18n.getString(_TL_('Twilight')) },
      { key: 'lighting_key_13', word: i18n.getString(_TL_('Flickering fire')) },
      { key: 'lighting_key_14', word: i18n.getString(_TL_('High contrast')) },
      { key: 'lighting_key_15', word: i18n.getString(_TL_('Side lighting')) },
      { key: 'lighting_key_16', word: i18n.getString(_TL_('Top lighting')) },
      { key: 'lighting_key_17', word: i18n.getString(_TL_('Bottom lighting')) },
      { key: 'lighting_key_18', word: i18n.getString(_TL_('Harsh lighting')) },
      { key: 'lighting_key_19', word: i18n.getString(_TL_('Soft, diffused lighting')) },
      { key: 'lighting_key_20', word: i18n.getString(_TL_('Split lighting')) },
      { key: 'lighting_key_21', word: i18n.getString(_TL_('Ambient lighting')) },
      { key: 'lighting_key_22', word: i18n.getString(_TL_('High-key lighting')) },
      { key: 'lighting_key_23', word: i18n.getString(_TL_('Low-key lighting')) },
      { key: 'lighting_key_24', word: i18n.getString(_TL_('Warm lighting')) },
      { key: 'lighting_key_25', word: i18n.getString(_TL_('Cool lighting')) },
      { key: 'lighting_key_26', word: i18n.getString(_TL_('Muted lighting')) },
      { key: 'lighting_key_27', word: i18n.getString(_TL_('At sunset')) },
    ]).filter(option => !usedOptions.find(usedOption => usedOption.key === option.key)),
  },
]).filter(x => x.words.length > 0);
